import mapClienteFacturaRecurrenteFromApi from "common/mappers/mapClienteFacturaRecurrenteFromApi"
import { DEFAULT_CURRENCY_ABREVIATURE } from "features/Contactos/constants"
import {
  clearLibrado,
  recalculate,
  setConceptos,
  setDescuento,
  setDiasPago,
  setFacturaRecurrenteItems,
  setFechaOperacion,
  setIdToEdit,
  setLibrado,
  setObservaciones,
  setRetencionPorcentaje,
  setRetencionTipoId,
  updateFormaPago,
  updateLogo,
} from "features/Crear/redux/slices/newDocumentoSlice"
import { setCurrency } from "features/Documentos/redux/documentosSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useCallback } from "react"

import { useCurrency } from "common/hooks/useCurrency"
import { handleUpdateTotalValue } from "features/Crear/components/ConceptosTable/utils"
import {
  setShowDescuento,
  setShowDiasPago,
  setShowFechaOperacion,
  setShowFormaPago,
  setShowLogo,
  setShowObservaciones,
  setShowRetencion,
  updateColor,
} from "features/Crear/redux/slices/newDocumentoSettingsSlice"
import { useTaxes } from "features/User/pages/Taxes/useTaxes"
import moment from "moment"
import { nanoid } from "nanoid"
import { globalSelector } from "routes/globalSlice"

function useFacturasRecurrentes() {
  const dispatch = useDispatch()

  const { formasPago, tiposImpuestosGenerales = [] } =
    useSelector(globalSelector)
  const { currencyListFormatDropdown } = useCurrency()
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  const { taxes } = useTaxes()
  const taxesFormatted = taxes.map((impuesto) => ({
    // @ts-expect-error TS(2698): Spread types may only be created from object types...
    ...impuesto,
    // @ts-expect-error TS(2339): Property 'nombre' does not exist on type 'never'.
    label: `${impuesto.nombre}`,
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
    value: impuesto.id,
    // @ts-expect-error TS(2339): Property 'valor' does not exist on type 'never'.
    fieldValue: impuesto.valor,
  }))
  const taxe = taxesFormatted.find((entry) => entry.nombre.includes("IVA"))

  const setFacturaRecurrenteToEdit = useCallback(
    (facturaRecurrente: $TSMigrationFixMe) => {
      const divisa = currencyListFormatDropdown.find(
        // @ts-expect-error TS(2339): Property 'simbolo' does not exist on type 'never'.
        (currency) => currency.simbolo === facturaRecurrente.divisa
        // @ts-expect-error TS(2339): Property 'value' does not exist on type 'never'.
      )?.value
      const mappedLibrado = mapClienteFacturaRecurrenteFromApi(
        facturaRecurrente?.cliente,
        facturaRecurrente?.libradorId
      )
      dispatch(setLibrado(mappedLibrado))
      dispatch(
        // @ts-expect-error TS(2354): Argument of type...
        setFacturaRecurrenteItems({
          intervalo: facturaRecurrente.intervalo,
          fechaFin: moment
            .utc(facturaRecurrente?.fechaFin)
            .local()
            .format("YYYY-MM-DD"),
          fechaInicio: moment
            .utc(facturaRecurrente?.fechaInicio)
            .local()
            .format("YYYY-MM-DD"),
          serie: facturaRecurrente?.serie,
        })
      )

      const conceptos = facturaRecurrente?.articuloDocumentos?.map(
        (articulo: $TSMigrationFixMe) => {
          const updatedSubtotal = handleUpdateTotalValue(
            articulo.articulo,
            articulo.cantidad
          )
          const impuesto = taxesFormatted.find((entry) => {
            return (
              entry.grupoImpuesto?.categoria?.includes(
                articulo.impuestoRepercutido
              ) && entry.valor === articulo.tarifaImpuesto
            )
          })

          return {
            id: nanoid(),
            concepto: articulo?.articulo?.concepto,
            cantidad: articulo?.cantidad,
            precioVenta: articulo?.articulo?.precioVenta || 0,
            impuestoArticuloTipoId: impuesto?.id || taxe?.id,
            impuestoArticuloPorcentaje: impuesto?.valor ?? taxe?.valor,
            subtotal: updatedSubtotal,
          }
        }
      )
      // @ts-expect-error TS(2354): Argument of type...
      dispatch(setShowLogo(Boolean(facturaRecurrente?.logo)))
      dispatch(
        // @ts-expect-error TS(2354): Argument of type...
        updateLogo({
          logo: `data:image/jpeg;base64, ${facturaRecurrente.logo?.fileAsBase64}`,
        })
      )
      // eslint-disable-next-line prefer-destructuring
      const formaPago = facturaRecurrente.formaPago
      const retencionId = tiposImpuestosGenerales.find(
        (entry: $TSMigrationFixMe) =>
          entry.nombre.includes(facturaRecurrente?.impuestoRetenido) &&
          Math.abs(entry?.valor) === facturaRecurrente?.tarifaImpuesto
      )
      // @ts-expect-error TS(2354): Argument of type...
      dispatch(updateFormaPago({ formaPago }))
      dispatch(setConceptos(conceptos))
      facturaRecurrente?.fechaOperacion &&
        dispatch(
          setFechaOperacion(
            // @ts-expect-error TS(2354): Argument of type...
            moment
              .utc(facturaRecurrente?.fechaOperacion)
              .local()
              .format("YYYY-MM-DD")
          )
        )

      // @ts-expect-error TS(2354): Argument of type...
      dispatch(setShowFechaOperacion(Boolean(facturaRecurrente.fechaOperacion)))

      dispatch(setDescuento(facturaRecurrente?.descuento))
      dispatch(setRetencionPorcentaje(retencionId?.valor))
      dispatch(setRetencionTipoId(retencionId?.id))
      // @ts-expect-error TS(2354): Argument of type...
      dispatch(setShowDescuento(Boolean(facturaRecurrente?.descuento)))
      // @ts-expect-error TS(2354): Argument of type...
      dispatch(setShowRetencion(Boolean(facturaRecurrente?.impuestoRetenido)))
      dispatch(setDiasPago(facturaRecurrente.diasPago))
      // @ts-expect-error TS(2354): Argument of type...
      dispatch(setShowDiasPago(Boolean(facturaRecurrente.diasPago)))
      // @ts-expect-error TS(2354): Argument of type...
      dispatch(setShowObservaciones(Boolean(facturaRecurrente.observaciones)))
      dispatch(setObservaciones(facturaRecurrente.observaciones))
      // @ts-expect-error TS(2354): Argument of type...
      dispatch(setShowFormaPago(Boolean(facturaRecurrente.formaPago)))
      dispatch(setCurrency(divisa))
      dispatch(recalculate())
      dispatch(setIdToEdit(facturaRecurrente.id))
      dispatch(updateColor(facturaRecurrente?.configuracion?.color))
    },
    // eslint-disable-next-line
    [currencyListFormatDropdown, dispatch, formasPago, taxe?.id, taxe?.valor]
  )

  const clearFacturaRecurrente = () => {
    // @ts-expect-error TS(2354): Argument of type...
    dispatch(setConceptos([]))
    dispatch(clearLibrado())
    // @ts-expect-error TS(2354): Argument of type...
    dispatch(setShowLogo(false))
    // @ts-expect-error TS(2354): Argument of type...
    dispatch(setShowFechaOperacion(false))
    // @ts-expect-error TS(2354): Argument of type...
    dispatch(setDescuento(0))
    dispatch(setRetencionPorcentaje(0))
    // @ts-expect-error TS(2354): Argument of type...
    dispatch(setShowDescuento(false))
    // @ts-expect-error TS(2354): Argument of type...
    dispatch(setShowRetencion(false))
    // @ts-expect-error TS(2354): Argument of type...
    dispatch(setDiasPago(null))
    // @ts-expect-error TS(2354): Argument of type...
    dispatch(setShowDiasPago(false))
    // @ts-expect-error TS(2354): Argument of type...
    dispatch(setShowObservaciones(false))
    // @ts-expect-error TS(2354): Argument of type...
    dispatch(setObservaciones(""))
    // @ts-expect-error TS(2354): Argument of type...
    dispatch(setShowFormaPago(false))
    // @ts-expect-error TS(2354): Argument of type...
    dispatch(setCurrency(DEFAULT_CURRENCY_ABREVIATURE))
    dispatch(
      // @ts-expect-error TS(2354): Argument of type...
      setFacturaRecurrenteItems({
        intervalo: 30,
        fechaInicio: moment.utc(new Date()).local().format("YYYY-MM-DD"),
        fechaFin: null,
        serie: "F",
      })
    )
    // @ts-expect-error TS(2354): Argument of type...
    dispatch(setIdToEdit(null))
    // @ts-expect-error TS(2354): Argument of type...
    dispatch(updateColor("#1a2543"))
  }
  return { setFacturaRecurrenteToEdit, clearFacturaRecurrente }
}

export default useFacturasRecurrentes
